import { useEffect } from "react";
import { setPageMeta } from "@/lib/api";
import { Splatter } from "@/components/Splatter";
import QuoteForm from "@/components/QuoteForm";
import { Upload, FileCheck2, Palette, Clock } from "lucide-react";

const STEPS = [
  { icon: Upload, title: "Envoyez votre fichier", desc: "STL, 3MF, OBJ, STEP ou ZIP — glissez-le directement dans le formulaire." },
  { icon: Palette, title: "Choisissez matière & couleur", desc: "PLA, PETG, résine... précisez vos préférences dans la description." },
  { icon: FileCheck2, title: "Recevez votre devis", desc: "Nous analysons votre modèle et vous envoyons un devis clair." },
  { icon: Clock, title: "Impression & livraison", desc: "Délais définis et respectés, du prototype à la série." },
];

export default function Print3D() {
  useEffect(() => { setPageMeta("Impression depuis votre fichier 3D — Tenay Ain-Pression", "Envoyez votre fichier 3D (STL, 3MF, OBJ, STEP, ZIP) et recevez un devis d'impression rapide."); }, []);
  return (
    <div>
      <section className="relative overflow-hidden border-b border-white/10">
        <Splatter />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-14">
          <h1 className="font-heading text-4xl sm:text-5xl font-black">Impression depuis votre <span className="text-[#0055FF]">fichier 3D</span></h1>
          <p className="mt-3 text-gray-400 max-w-2xl">Vous avez déjà votre modèle ? Envoyez-le nous, on s'occupe de l'impression avec le plus grand soin.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <div key={s.title} className="fade-up rounded-2xl border border-[#222] bg-[#0A0A0A] p-6" style={{ animationDelay: `${i * 70}ms` }}>
            <s.icon className="w-8 h-8 text-[#E6007E]" />
            <h3 className="mt-3 font-heading font-bold text-lg">{s.title}</h3>
            <p className="mt-2 text-sm text-gray-400">{s.desc}</p>
          </div>
        ))}
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 pb-12">
        <QuoteForm defaultCategory="impression-fichier-3d" lockCategory />
      </div>
    </div>
  );
}
